import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { RouteGuardService } from "./route-guard.service";

import { ErrorComponent } from "./components/error/error.component";
import { LoginComponent } from "./components/login/login.component";
import { UserGeneralComponent } from "./components/user/user-general/user-general.component";
import { UserCreateComponent } from "./components/user/user-create/user-create.component";
import { UserUpdateComponent } from "./components/user/user-update/user-update.component";
import { UserProfileComponent } from "./components/user/user-profile/user-profile.component";
import { ChecklistCreateComponent } from "./components/checklist/checklist-create/checklist-create.component";
import { ChecklistUpdateComponent } from "./components/checklist/checklist-update/checklist-update.component";
import { ChecklistGeneralComponent } from "./components/checklist/checklist-general/checklist-general.component";
import { ChecklistDetailComponent } from "./components/checklist/checklist-detail/checklist-detail.component";
import { ChecklistCategoryDetailComponent } from "./components/checklist-category/checklist-category-detail/checklist-category-detail.component";
import { ChecklistCategoryCreateComponent } from "./components/checklist-category/checklist-category-create/checklist-category-create.component";
import { ChecklistCategoryUpdateComponent } from "./components/checklist-category/checklist-category-update/checklist-category-update.component";
import {
  ChecklistSubcategoryCreateComponent
} from "./components/checklist-subcategory/checklist-subcategory-create/checklist-subcategory-create.component";
import {
  ChecklistSubcategoryUpdateComponent
} from "./components/checklist-subcategory/checklist-subcategory-update/checklist-subcategory-update.component";
import { ContractGeneralComponent } from "./components/contract/contract-general/contract-general.component";
import { ContractDetailComponent } from "./components/contract/contract-detail/contract-detail.component";
import { ContractCreateComponent } from "./components/contract/contract-create/contract-create.component";
import { ContractUpdateComponent } from "./components/contract/contract-update/contract-update.component";
import { InspectionImportComponent } from "./components/inspection/inspection-import/inspection-import.component";
import { InspectionDetailComponent } from "./components/inspection/inspection-detail/inspection-detail.component";
import { InspectionOrderDetailComponent } from './components/inspection-order/inspection-order-detail/inspection-order-detail.component';
import { InspectionGeneralComponent } from "./components/inspection/inspection-general/inspection-general.component";
import { InspectionChecklistComponent } from "./components/inspection/inspection-checklist/inspection-checklist.component";
import {InspectionCreateComponent} from "./components/inspection/inspection-create/inspection-create.component";
import {InspectionUpdateComponent} from "./components/inspection/inspection-update/inspection-update.component";
import {
  InspectionOrderCreateComponent
} from "./components/inspection-order/inspection-order-create/inspection-order-create.component";
import {
  InspectionOrderUpdateComponent
} from "./components/inspection-order/inspection-order-update/inspection-order-update.component";
import {
  InspectionDeliveryRequestCreateComponent
} from "./components/inspection-delivery-request/inspection-delivery-request-create/inspection-delivery-request-create.component";
import {
  InspectionDeliveryRequestUpdateComponent
} from "./components/inspection-delivery-request/inspection-delivery-request-update/inspection-delivery-request-update.component";
import {
  InspectionDocumentCreateComponent
} from "./components/inspection-document/inspection-document-create/inspection-document-create.component";
import {ContractReportComponent} from "./components/contract/contract-report/contract-report.component";

const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'login'
  },
  {
    path: 'login',
    pathMatch: 'full',
    component: LoginComponent
  },
  {
    path: 'error',
    pathMatch: 'full',
    component: ErrorComponent
  },
  {
    path: 'checklist',
    pathMatch: 'full',
    component: ChecklistGeneralComponent,
    canActivate: [RouteGuardService],
    data: {role: 1}
  },
  {
    path: 'checklist/create',
    pathMatch: 'full',
    component: ChecklistCreateComponent,
    canActivate: [RouteGuardService],
    data: {role: 1}
  },
  {
    path: 'checklist/:id',
    pathMatch: 'prefix',
    component: ChecklistDetailComponent,
    canActivate: [RouteGuardService],
    data: {role: 1}
  },
  {
    path: 'checklist/update/:id',
    pathMatch: 'prefix',
    component: ChecklistUpdateComponent,
    canActivate: [RouteGuardService],
    data: {role: 1}
  },
  {
    path: 'checklist-category/create/:id',
    pathMatch: 'full',
    component: ChecklistCategoryCreateComponent,
    canActivate: [RouteGuardService],
    data: {role: 1}
  },
  {
    path: 'checklist-category/update/:id',
    pathMatch: 'full',
    component: ChecklistCategoryUpdateComponent,
    canActivate: [RouteGuardService],
    data: {role: 1}
  },
  {
    path: 'checklist-category/:id',
    pathMatch: 'full',
    component: ChecklistCategoryDetailComponent,
    canActivate: [RouteGuardService],
    data: {role: 1}
  },
  {
    path: 'checklist-subcategory/create/:id',
    pathMatch: 'full',
    component: ChecklistSubcategoryCreateComponent,
    canActivate: [RouteGuardService],
    data: {role: 1}
  },
  {
    path: 'checklist-subcategory/update/:id',
    pathMatch: 'full',
    component: ChecklistSubcategoryUpdateComponent,
    canActivate: [RouteGuardService],
    data: {role: 1}
  },
  {
    path: 'contract',
    pathMatch: 'full',
    component: ContractGeneralComponent,
    canActivate: [RouteGuardService],
    data: {role: 1}
  },
  {
    path: 'contract-report',
    pathMatch: 'full',
    component: ContractReportComponent,
    canActivate: [RouteGuardService],
    data: {role: 1}
  },
  {
    path: 'contract/create',
    pathMatch: 'full',
    component: ContractCreateComponent,
    canActivate: [RouteGuardService],
    data: {role: 1}
  },
  {
    path: 'contract/update/:id',
    pathMatch: 'prefix',
    component: ContractUpdateComponent,
    canActivate: [RouteGuardService],
    data: {role: 1}
  },
  {
    path: 'contract/:id',
    pathMatch: 'prefix',
    component: ContractDetailComponent,
    canActivate: [RouteGuardService],
    data: {role: 1}
  },
  {
    path: 'inspection-general',
    pathMatch: 'full',
    component: InspectionGeneralComponent,
    canActivate: [RouteGuardService],
    data: {role: 3}
  },
  {
    path: 'schedule',
    pathMatch: 'full',
    component: InspectionGeneralComponent,
    canActivate: [RouteGuardService],
    data: {role: 2}
  },
  {
    path: 'inspection',
    pathMatch: 'full',
    component: InspectionGeneralComponent,
    canActivate: [RouteGuardService],
    data: {role: 4}
  },
  {
    path: 'inspection/create',
    pathMatch: 'full',
    component: InspectionCreateComponent,
    canActivate: [RouteGuardService],
    data: {role: 1}
  },
  {
    path: 'inspection/update/:id',
    pathMatch: 'prefix',
    component: InspectionUpdateComponent,
    canActivate: [RouteGuardService],
    data: {role: 1}
  },
  {
    path: 'inspection/import',
    pathMatch: 'prefix',
    component: InspectionImportComponent,
    canActivate: [RouteGuardService],
    data: {role: 1}
  },
  {
    path: 'inspection/:id',
    pathMatch: 'prefix',
    component: InspectionDetailComponent,
    canActivate: [RouteGuardService],
    data: {role: 1}
  },
  {
    path: 'inspection/order/:id',
    pathMatch: 'prefix',
    component: InspectionOrderDetailComponent,
    canActivate: [RouteGuardService],
    data: {role: 1}
  },
  {
    path: 'inspection/order/create/:id',
    pathMatch: 'prefix',
    component: InspectionOrderCreateComponent,
    canActivate: [RouteGuardService],
    data: {role: 1}
  },
  {
    path: 'inspection/order/update/:id',
    pathMatch: 'prefix',
    component: InspectionOrderUpdateComponent,
    canActivate: [RouteGuardService],
    data: {role: 1}
  },
  {
    path: 'inspection/rdc/create/:id',
    pathMatch: 'prefix',
    component: InspectionDeliveryRequestCreateComponent,
    canActivate: [RouteGuardService],
    data: {role: 1}
  },
  {
    path: 'inspection/rdc/update/:id',
    pathMatch: 'prefix',
    component: InspectionDeliveryRequestUpdateComponent,
    canActivate: [RouteGuardService],
    data: {role: 1}
  },
  {
    path: 'inspection/checklist/:id',
    pathMatch: 'prefix',
    component: InspectionChecklistComponent,
    canActivate: [RouteGuardService],
    data: {role: 4}
  },
  {
    path: 'inspection/document/create/:id',
    pathMatch: 'prefix',
    component: InspectionDocumentCreateComponent,
    canActivate: [RouteGuardService],
    data: {role: 1}
  },
  {
    path: 'user',
    pathMatch: 'full',
    component: UserGeneralComponent,
    canActivate: [RouteGuardService],
    data: {role: 1}
  },
  {
    path: 'user/create',
    pathMatch: 'full',
    component: UserCreateComponent,
    canActivate: [RouteGuardService],
    data: {role: 1}
  },
  {
    path: 'user/update/:id',
    pathMatch: 'prefix',
    component: UserUpdateComponent,
    canActivate: [RouteGuardService],
    data: {role: 1}
  },
  {
    path: 'user/:id',
    pathMatch: 'prefix',
    component: UserProfileComponent,
    canActivate: [RouteGuardService],
    data: {role: 1}
  },
  {
    path: '**',
    redirectTo: 'error'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
  providers: [RouteGuardService]
})
export class AppRoutingModule { }
